export function fileTooLargeMessage(maxBytes) {
    return `File must be ${maxBytes / (1024 * 1024)} MB or smaller.`;
}
//# sourceMappingURL=file-too-large-message.js.map